import React from 'react';
import { CreateDebtorForm } from '@/components/forms/CreateDebtorForm';


export const CreateDebtorsPage = () => {
    return <CreateDebtorForm />;
};